import React from 'react'
import PropTypes from 'prop-types'
import { Link, Pane, minorScale, majorScale } from 'evergreen-ui'
import { browserHistory } from 'react-router'
import classnames from 'classnames'
import css from './SearchResultRow.module.css'

const SearchResultRow = ({
  isSelected,
  hasTopBorder,
  children,
  url,
  onClick
}) => (
  <Link
    width="100%"
    height="100%"
    to={url}
    textDecoration="none"
    display="block"
    cursor="pointer"
    data-is-selected={isSelected}
    onMouseDown={() => {
      onClick()
      browserHistory.push(url)
    }}
  >
    <Pane
      paddingLeft={majorScale(6)}
      paddingRight={majorScale(3)}
      paddingY={minorScale(3)}
      borderTop={hasTopBorder ? 'muted' : undefined}
      className={classnames(css.SearchResultRow, {
        [css.Selected]: isSelected
      })}
      display="flex"
      alignItems="center"
    >
      {children}
    </Pane>
  </Link>
)

SearchResultRow.propTypes = {
  isSelected: PropTypes.bool,
  hasTopBorder: PropTypes.bool,
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

SearchResultRow.defaultProps = {
  isSelected: false,
  hasTopBorder: false,
  onClick() {}
}

export default SearchResultRow
